import React from "react"
import { Box, Heading } from "@chakra-ui/react"

import Link from "@components/Link"
import { SectionProps, withSection } from "@app/hoc/Section"
import { useRoutes } from "@app/hooks/useRoutes"
import { useContent } from "@app/hooks/useContent"
import "./YotpoReview.css"

export type TextProps = GatsbyTypes.SanitySectionText & SectionProps

const Text = ({ content: rawContent, link: rawLink, title, theme, alignment, innerRef, handleTrackingClick }: TextProps) => {
  const { urlResolver } = useRoutes()
  const link = urlResolver(rawLink)

  const { getContent } = useContent()
  const content = getContent({ content: rawContent })

  return (
    <Box
      ref={innerRef}
      as="section"
      bg={theme === "Dark" ? "brand.beige.dark" : "white"}
      textAlign={alignment?.toString() || "center"}
      py={4}
      minW={"unset"}
      px={[2, "0 !important"]}
    >
      <Box w={["unset", "648px"]} margin={"auto"}>
        {title && (
          <Heading as="h2" size="xl" mb={4}>
            {title}
          </Heading>
        )}
        <Box>{content}</Box>
        {link?.url && (
          <Link title={link?.title} to={link?.url} onClick={handleTrackingClick}>
            {link?.title}
          </Link>
        )}
      </Box>
    </Box>
  )
}

export default React.memo(withSection(Text))
